export function OutlineCostoImjIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.7248 4.49805H15.6661C13.9449 4.49805 12.5496 5.89336 12.5496 7.61457V7.67325C12.5496 9.39445 13.9449 10.7898 15.6661 10.7898H15.7248C17.446 10.7898 18.8413 9.39445 18.8413 7.67325V7.61457C18.8413 5.89336 17.446 4.49805 15.7248 4.49805Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.3358 15.3548C22.3358 14.6311 21.749 14.0508 21.0318 14.0508H10.274C9.55024 14.0508 8.96997 14.6376 8.96997 15.3548"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M3.76025 0V2.65361"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M3.76025 9.74805V12.4017"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M6.7988 3.31779C6.5054 3.18739 6.08161 3.02439 5.56654 2.88747C4.9667 2.731 4.41251 2.58756 3.76052 2.64624C3.43452 2.67232 1.93494 2.80923 1.51767 3.85894C1.36119 4.26318 1.36771 4.78477 1.60242 5.19552C1.97406 5.84752 2.80209 6.03007 3.76052 6.24523C4.64071 6.44083 4.98626 6.36259 5.50786 6.72771C5.69693 6.86462 6.06205 7.12542 6.20549 7.6079C6.35545 8.10341 6.18593 8.54024 6.10117 8.70324C5.91209 9.10096 5.60565 9.30959 5.46874 9.40087C4.94714 9.74643 4.41903 9.74643 3.754 9.73339C2.73689 9.72035 1.94798 9.46607 1.45247 9.29655C1.00911 9.14659 0.650517 8.99012 0.39624 8.86624"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeMiterlimit="10"
      />
      <path
        d="M8.91797 16.6055V23.2493"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M11.4282 23.2483V17.25H11.7021L14.3035 22.6485L16.8919 17.25H17.1592V23.2483"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
      <path
        d="M22.3746 16.6191V21.4439C22.3551 21.6134 22.2899 22.0437 21.9443 22.3827C21.3575 22.963 20.4839 22.7609 20.3339 22.7218C19.6102 22.5523 19.2125 22.0176 19.1082 21.8612"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinejoin="round"
      />
    </svg>
  );
}
